import { EXCLUDED_APPOINTMENTS } from '../../../shared/utils/constants';

const validate = (values) => {
  const errors = {};

  if (!values.dateNote) {
    errors.dateNote = 'Informe a data do apontamento';
  }

  if (!values.hourNote) {
    errors.hourNote = 'Informe a hora do apontamento';
  }

  if (!values.classesNames) {
    errors.classesNames = 'Selecione ao menos uma turma';
  }

  if (!values.item1) {
    errors.item1 = 'Selecione o primeiro item';
  }

  if (!values.item2) {
    errors.item2 = 'Selecione o segundo item';
  }

  if (values.selectedItems && values.selectedItems.length > 0) {
    if (
      values.selectedItems[values.selectedItems.length - 1].addOn &&
      !values.noteComplement
    ) {
      errors.noteComplement = 'Este campo não pode ficar vazio.';
    }
  }
  if (values.appoitmentStudent && values.appoitmentStudent.length === 0) {
    errors.appoitmentStudent = 'Gere os apontamentos!';
  }
  if (
    values.item2 &&
    values.item2.id &&
    EXCLUDED_APPOINTMENTS.map((item) => item.id).indexOf(values.item2.id) !==
      -1 &&
    !values.responsible
  ) {
    errors.responsible = 'Este campo não pode ficar vazio.';
  }

  return errors;
};

export default validate;
